import React from "react";
import styled from "styled-components";
import Callout from "../../components/molecules/Callout";
import appConfig from "../../lib/appConfig";

const StyledContainer = styled.div`
  position: absolute;
  left: 50%;
  z-index: 1;
  transform: translate(-50%, 0);
  margin-top: 110px;
  box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.25);
  font-weight: 500;
  @media (max-width: ${appConfig.tabletWidth}px) {
    max-width: 50vw;
  }
  @media (max-width: ${appConfig.mobileWidth}px) {
    font-size: 12px;
  }
`;

interface IProps {
  text: string;
  type: string;
}

function MapMessage({ text, type }: IProps) {
  return (
    <StyledContainer>
      <Callout type={type}>{text}</Callout>
    </StyledContainer>
  );
}

export default MapMessage;
